module.exports = __webpack_public_path__ + "img/1471420088.c2b7122e.jpg";